module.exports = __webpack_public_path__ + "img/vertical_4_1_8011.d971966c.png";